/**
 * *Prefer passing configs as props*
 *
 * This function gets a tenant config value using the sfTenant global object
 *
 * Using globals from outside of the React context is not considered to be best practice.
 *
 * @param {string} name - Tenant config name
 * @returns {*} Tenant config value
 */
export const getTenantConfig = name => sfTenant.getTenantConfig(name);

/**
 * *Prefer passing custom language as props*
 *
 * This function gets tenant custom language using the sfTenant global object
 *
 * Using globals from outside of the React context is not considered to be best practice.
 *
 * @param {string} customWord - Keyword to get custom language by
 * @param {boolean} forceLowerCase - Indicates whether or not to return the custom language all lower case
 * @returns {string} Tenant config value
 */
export const getWord = (customWord, forceLowerCase) => sfTenant.language.getWord(customWord, forceLowerCase);

export const tenantTimeZoneLongForm = () => sfTenant.tenantTimeZoneLongForm;
